import { calcDiscount, calcTotalPrice, calcVariationFees } from "~/helpers/price";
import type { VisaForm } from "~/types";

export default function useFormPrice(form: Ref<VisaForm>) {
  const { currency } = useBranch();
  const preDiscountTotal = computed(() => calcTotalPrice(form.value, currency, { skipDiscount: true }));
  const discountAmount = computed(() => calcDiscount(preDiscountTotal.value, form.value.discount));
  const total = computed(() => calcTotalPrice(form.value, currency));
  const variationFees = computed(() => calcVariationFees(form.value, currency));

  return {
    preDiscountTotal,
    discountAmount,
    variationFees,
    total
  };
}